import React, { FC } from 'react';

import { TabProps } from './CustomerSites.props';
import SitesTable from './SitesTable';

const AllSites: FC<TabProps> = (props) => (
  <SitesTable {...props} queryScope="all" />
);

export default AllSites;
